import type { LoopConfiguration } from '@/types/loop-configuration';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';

/**
 * Get loop configuration from s-collection attribute
 */
const getLoopConfiguration = (selector: string): LoopConfiguration | null => {
  const template = getTemplateIframeDocument();
  if (!template) {
    return null;
  }

  const element = template.querySelector(selector);
  if (!element) {
    return null;
  }

  const collectionAttr = element.getAttribute('s-collection');
  const itemAttr = element.getAttribute('s-item');
  const orderAttr = element.getAttribute('s-order');
  const nbAttr = element.getAttribute('s-nb');

  if (!collectionAttr || !itemAttr) {
    return null;
  }

  const config: LoopConfiguration = {
    enabled: true,
    collection: collectionAttr,
    iterator: itemAttr,
  };

  // Parse s-order if present
  if (orderAttr) {
    try {
      config.order = JSON.parse(orderAttr);
    } catch (e) {
      console.error('Error parsing s-order attribute:', e);
    }
  }

  // Parse s-nb if present
  if (nbAttr) {
    const limit = parseInt(nbAttr, 10);
    if (!Number.isNaN(limit)) {
      config.limit = limit;
    }
  }

  return config;
};

export default getLoopConfiguration;
